<template>
    <div class="d-flex flex-column" style="height: 100%; overflow: hidden">
        <div
            class="d-flex flex-column pa-0 py-0 flex-grow-1 my-1 px-0 mt-0 mb-0 pt-0 containerFull"
            style="height: 100%; overflow: hidden"
            :class="{ paddingRight: true }"
        >
            <div class="d-flex flex-column flex-grow-1" style="width: 100%; padding: 20px; z-index: 9">
                <v-sheet class="rounded-lg pa-4 pt-6 pb-3 softShadow agentBox">
                    <h4 class="d-flex flex-row mb-6 mt-2 justify-center">Välkommen att ringa till oss</h4>
                    <v-divider />
                    <div class="d-flex flex-column py-6">
                        <div v-for="item in config.customer.simplePhoneText" :key="item.heading">
                            <div :style="{ color: config.customer.primaryColorHex }">{{ item.heading }}</div>
                            <div class="pb-3">
                                <span v-dompurify-html="validatePhone(item)"></span>
                            </div>
                        </div>
                    </div>
                </v-sheet>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Phone',
        props: ['config', 'primaryColor', 'secondaryColor', 'primaryGradient'],
        data() {
            return {
                waitTimeColor: '',
                waitTimeMinutes: 2,
                waitTimeIcon: '',
                addCallbackVerified: true,
                smsView: true,
                message: '',
                timesToCallback: ['Omgående', 'Idag', 'Imorgon'],
                phoneNumber: '',
                valid: false,
                lazy: false,
                rulesTextField: [
                    (v) => v.length <= 160 || 'Max 160 ord.',
                    (v) => !!v || 'Du måste skriva något.',
                    (v) => v.length > 5 || 'Du måste skriva minst 5 ord.'
                ],
                rulesPhoneNumber: [
                    (v) => v.length >= 6 || 'Numret måste vara minst 6 tecken',
                    (v) => !!v || 'Du måste ange ett nummer'
                ],
                rulesWhenCallingBack: [(v) => !!v || 'Du måste ange en tidpunkt vi kan ringa upp.'],
                value: '',
                primaryGradientStyle: {
                    backgroundColor: this.primaryGradient,
                    background: this.primaryGradient,
                    color: this.secondaryColor
                },
                primaryStyle: {
                    color: this.primaryColor
                }
            };
        },
        computed: {
            waitTimeColorR() {
                return this.waitTimeColor;
            },

            waitTimeIconMdi() {
                return this.waitTimeIcon;
            },
            waitTime() {
                if (this.waitTimeMinutes > 20) {
                    this.waitTimeIcon = 'mdi-emoticon-sad';
                    this.waitTimeColor = 'red';
                    this.timesToCallback[0] = 'Omgående (över 20 min)';
                    return 'Lång väntetid, över 20 minuter';
                } else if (this.waitTimeMinutes < 4) {
                    this.waitTimeColor = this.primaryColor;
                    this.waitTimeIcon = 'mdi-emoticon';
                    this.timesToCallback[0] = 'Omgående (~3 minuter)';
                    return 'Ingen i kö';
                } else {
                    this.waitTimeIcon = 'mdi-emoticon-neutral';
                    this.waitTimeColor = this.primaryColor;
                    this.timesToCallback[0] = 'Omgående (~' + this.waitTimeMinutes + ' minuter)';
                    return 'Väntetid: ' + this.waitTimeMinutes + ' minuter';
                }
            }
        },
        methods: {
            callNow(nr) {
                window.location.href = 'callto:' + nr;
            },
            validatePhone(item) {
                //regex to validate phone number
                return item.heading === 'Telefon' ? `<a href='tel:${item.number}'>${item.number}</a>` : item.number;
            },
            addCallback(userId, email) {
                const visitorId = localStorage.getItem('visitorId');

                const dataToSend = {
                    userId: 0,
                    message: this.message,
                    phoneNumber: this.phoneNumber,
                    type: 'callback',
                    visitorId: visitorId,
                    agentName: 'Test',
                    agentUserId: 0,
                    agentEmail: email,
                    visitorInfo: { visitorEmail: this.phoneNumber }
                };

                this.$store.dispatch('sendCallback', dataToSend);

                this.smsView = false;
                let self = this;
                setTimeout(() => {
                    self.smsView = false;
                }, 5000);
            }
        }
    };
</script>

<style scoped>
    :deep .v-label {
        font-size: 12px !important;
    }
    :deep .v-label--active {
        font-size: 12px !important;
        font-weight: bold;
    }

    .v-label {
        font-size: 12px !important;
    }

    .v-select {
        font-size: 12px !important;
    }

    :deep .v-text-field__details {
        padding-top: 10px !important;
    }

    :deep .v-messages {
        text-align: center !important;
    }
    :deep .v-messages__message {
        line-height: 1.5em !important;
    }
</style>
